import { render, staticRenderFns } from "./index.vue?vue&type=template&id=fbbe67a4&lang=html&"
import script from "./userCoupon.js?vue&type=script&lang=js&"
export * from "./userCoupon.js?vue&type=script&lang=js&"
import style0 from "./userCoupon.styl?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports